import { useSelector } from 'react-redux';

import { selectCurrentCityDomain } from '@r1-frontend/entities/stores/city/selectors';

export const useIsMsk = () => {
    const domain = useSelector(selectCurrentCityDomain);
    return ['msk', 'msk-tc'].includes(domain);
};
